import { ComponentType, Suspense, useState, useEffect } from "react";
import { FullScreenLoader, SiteLoader } from "../Components/Components";

export function withLazy<T extends object>(Component: ComponentType<T>) {
  return function LazyComponent(props: T) {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      const timer = setTimeout(() => setIsLoading(false), 300); // Ensuring smooth transition
      return () => clearTimeout(timer);
    }, []);

    return (
      <Suspense fallback={isLoading ? null : ""}>
        <Component {...props} />
      </Suspense>
    );
  };
}

export function loadChunkWithRetry<T extends ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
  retries = 3
): Promise<{ default: T }> {
  return new Promise((resolve, reject) => {
    const attempt = () => {
      importFunc()
        .then(resolve)
        .catch((error) => {
          if (retries === 0) {
            reject(error);
          } else {
            retries--;
            setTimeout(attempt, 1000);
          }
        });
    };
    attempt();
  });
}